import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
    sessionId: null,
    isSessionActive: false,
    votes: [],
    storedVotes: [],
    protectiveMeasures: [],
    isLoading: false,
    error: null,
};

const anonymousScoringSlice = createSlice({
    name: "anonymousScoring",
    initialState,
    reducers: {
        startSessionRequest: (state) => {
            state.isLoading = true;
        },
        startSessionSuccess: (state, action) => {
            state.isLoading = false;
            state.sessionId = action.payload.sessionId;
            state.isSessionActive = true;
            state.error = null;
            toast.success("Session started successfully", {
                autoClose: 2000,
                className: "toast-success",
            });
        },
        startSessionFailure: (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
            toast.error("Failed to start session", {
                autoClose: 2000,
                className: "toast-error",
            });
        },

        submitVoteRequest: () => {},
        submitVoteSuccess: () => {
            toast.success("Vote submitted successfully", {
                autoClose: 2000,
                className: "toast-success",
            });
        },
        submitVoteFailure: () => {
            toast.error("Failed to submit vote (No Active Session)", {
                autoClose: 2000,
                className: "toast-error",
            });
        },

        fetchResultsRequest: () => {},
        fetchResultsSuccess: (state, action) => {
            state.votes = action.payload.votes;
            state.error = null;
            state.isSessionActive = action.payload.isSessionActive;
        },
        fetchResultsFailure: () => {},

        stopSessionRequest: () => {},
        stopSessionSuccess: (state) => {
            state.isLoading = false;
            state.sessionId = null;
            state.isSessionActive = false;
            state.error = null;
            toast.success("Session stopped successfully", {
                autoClose: 2000,
                className: "toast-success",
            });
        },
        stopSessionFailure: () => {},

        saveVotingDataRequest: () => {},
        saveVotingDataSuccess: (state) => {
            state.error = null;
            toast.success("Voting data saved successfully", {
                autoClose: 2000,
                className: "toast-success",
            });
        },
        saveVotingDataFailure: () => {
            toast.error("Failed to save voting data", {
                autoClose: 2000,
                className: "toast-error",
            });
        },

        getVotingDataRequest: () => {},
        getVotingDataSuccess: (state, action) => {
            state.storedVotes = action.payload.storedVotes;
            state.error = null;
            toast.success("Voting data fetched successfully", {
                autoClose: 2000,
                className: "toast-success",
            });
        },
        getVotingDataFailure: (state, action) => {
            state.storedVotes = null;
            state.error = action.payload.message;
            console.log("Error in getVotingDataFailure: No votes found for the given event_task_id");
        },
        
        clearVotingDataRequest: () => {},
        clearVotingDataSuccess: (state, action) => {
            state.storedVotes = null;
            state.error = null;
            toast.success("Voting data cleared successfully", {
                autoClose: 2000,
                className: "toast-success",
            });
        },
        clearVotingDataFailure: (state, action) => {
            state.storedVotes = null;
            state.error = action.payload.message;
            toast.error("Failed to clear voting data", {
                autoClose: 2000,
                className: "toast-error",
            });
        },

        getProtectiveMeasuresRequest: () => {},
        getProtectiveMeasuresSuccess: (state, action) => {
            state.protectiveMeasures = action.payload.protectiveMeasures;
            state.error = null;
        },
        getProtectiveMeasuresFailure: (state, action) => {
            state.error = action.payload.message;
            toast.error("Failed to fetch protective measures", {
                autoClose: 2000,
                className: "toast-error",
            });
        },
    },
});

export default anonymousScoringSlice.reducer;
export const {
    startSessionRequest,
    startSessionSuccess,
    startSessionFailure,
    submitVoteRequest,
    submitVoteSuccess,
    submitVoteFailure,
    fetchResultsRequest,
    fetchResultsSuccess,
    fetchResultsFailure,
    stopSessionRequest,
    stopSessionSuccess,
    stopSessionFailure,
    saveVotingDataRequest,
    saveVotingDataSuccess,
    saveVotingDataFailure,
    getVotingDataRequest,
    getVotingDataSuccess,
    getVotingDataFailure,
    clearVotingDataRequest,
    clearVotingDataSuccess,
    clearVotingDataFailure,
    getProtectiveMeasuresRequest,
    getProtectiveMeasuresSuccess,
    getProtectiveMeasuresFailure,
} = anonymousScoringSlice.actions